<template>
  <div class="main-container">
    <div style="padding-top: 24px">优惠券可用班级：</div>
    <List
      class="list"
      ref="list"
      :url="'/api/app/couponGoods?type=5&coupon_id=' + $route.query.id"
      :limit="15"
      :alwaysShowPager="true"
    >
      <template v-slot="{ list }">
        <div class="course-list clearfix">
          <ClassesItem v-for="item in list" :key="item.id" :item="item"></ClassesItem>
        </div>
        <EmptyNew v-if="list.length == 0" class="classes-empty" title="暂无班级安排，敬请期待！" />
      </template>
    </List>
  </div>
</template>
<script>
import List from '@/components/List.vue';
import ClassesItem from '@/modules/stu/components/classes/ClassesItem.vue';

export default {
  name: 'ClassesCoupon',
  components: { List, ClassesItem },
};
</script>
<style lang="scss" scoped>
.list {
  padding: 32px 0;
}
</style>
